import gql from "graphql-tag";

export const CHECK_BLACK_LIST = gql`
  mutation checkBlackList($where: ProjectWhereInput) {
    checkBlackList(where: $where) {
      status
    }
  }
`;

const security = {
  CHECK_BLACK_LIST,
};

export default security;
